import PlanoAcao from '../types/negocio/PlanoAcao';
import PlanoAcaoResultadoConsulta from '../types/negocio/PlanoAcaoResultadoConsulta';
import AcaoPorArea from '../types/negocio/AcaoPorArea';
import api from './api';
import BaseService from './BaseService';

class PlanoAcaoService extends BaseService<PlanoAcao> {
  constructor() {
    super('plano-acao', api);
  }

  async buscarPlanos(filtros?: {
    estrategia?: string;
    responsavel?: string;
    prazo?: string;
    area?: string;
    status?: string;
    termo?: string;
    verArquivados?: boolean;
  }): Promise<PlanoAcaoResultadoConsulta[]> {
    try {
      const params = { ...filtros };
      const response = await this.api.get(`api/${this.route}/buscar`, { params });
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar planos de ação:', error);
      throw error;
    }
  }

  async arquivarPlano(guid: string): Promise<void> {
    try {
      await this.api.patch(`api/${this.route}/${guid}/arquivar`);
    } catch (error) {
      console.error('Erro ao arquivar plano de ação:', error);
      throw error;
    }
  }

  async buscarAcoesPorArea(): Promise<AcaoPorArea[]> {
    try {
      const response = await this.api.get(`api/${this.route}/estatisticas/por-area`);
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar estatísticas de ações por área:', error);
      throw error;
    }
  }
}

export const planoAcaoService = new PlanoAcaoService();